/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Logo_AltInputs */



/**
* | output |
* | --- |
* | "Ateliere logo" |
*
* @param {Ateliere_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_logo_alt = /** @type {((inputs?: Ateliere_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Logo Ateliere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ateliere Logo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Logo dell'Ateliere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("логотип Ateliere")
	if (locale === "es") return /** @type {LocalizedString} */ ("Logotipo del taller")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Ateliere 标志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アトリエールのロゴ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एटेलियर लोगो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Logotipo do Ateliere")
	return /** @type {LocalizedString} */ ("Ateliere logo")
});